import buildingAD from "@/data/buildings/polygons/AD.json";
import buildingB from "@/data/buildings/polygons/B.json";
import buildingBB from "@/data/buildings/polygons/BB.json";
import buildingBH from "@/data/buildings/polygons/BH.json";
import buildingCC from "@/data/buildings/polygons/CC.json";
import buildingCI from "@/data/buildings/polygons/CI.json";
import buildingCJ from "@/data/buildings/polygons/CJ.json";
import buildingCL from "@/data/buildings/polygons/CL.json";
import buildingD from "@/data/buildings/polygons/D.json";
import buildingDO from "@/data/buildings/polygons/DO.json";
import buildingEN from "@/data/buildings/polygons/EN.json";
import buildingER from "@/data/buildings/polygons/ER.json";
import buildingEV from "@/data/buildings/polygons/EV.json";
import buildingFA from "@/data/buildings/polygons/FA.json";
import buildingFB from "@/data/buildings/polygons/FB.json";
import buildingFC from "@/data/buildings/polygons/FC.json";
import buildingFG from "@/data/buildings/polygons/FG.json";
import buildingGA from "@/data/buildings/polygons/GA.json";
import buildingGE from "@/data/buildings/polygons/GE.json";
import buildingGM from "@/data/buildings/polygons/GM.json";
import buildingGN from "@/data/buildings/polygons/GN.json";
import buildingGS from "@/data/buildings/polygons/GS.json";
import buildingH from "@/data/buildings/polygons/H.json";
import buildingHA from "@/data/buildings/polygons/HA.json";
import buildingHB from "@/data/buildings/polygons/HB.json";
import buildingHC from "@/data/buildings/polygons/HC.json";
import buildingHU from "@/data/buildings/polygons/HU.json";
import buildingJR from "@/data/buildings/polygons/JR.json";
import buildingK from "@/data/buildings/polygons/K.json";
import buildingLB from "@/data/buildings/polygons/LB.json";
import buildingLD from "@/data/buildings/polygons/LD.json";
import buildingLS from "@/data/buildings/polygons/LS.json";
import buildingM from "@/data/buildings/polygons/M.json";
import buildingMB from "@/data/buildings/polygons/MB.json";
import buildingMI from "@/data/buildings/polygons/MI.json";
import buildingMU from "@/data/buildings/polygons/MU.json";
import buildingP from "@/data/buildings/polygons/P.json";
import buildingPC from "@/data/buildings/polygons/PC.json";
import buildingPR from "@/data/buildings/polygons/PR.json";
import buildingPS from "@/data/buildings/polygons/PS.json";
import buildingPT from "@/data/buildings/polygons/PT.json";
import buildingPY from "@/data/buildings/polygons/PY.json";
import buildingQ from "@/data/buildings/polygons/Q.json";
import buildingR from "@/data/buildings/polygons/R.json";
import buildingRA from "@/data/buildings/polygons/RA.json";
import buildingRF from "@/data/buildings/polygons/RF.json";
import buildingRR from "@/data/buildings/polygons/RR.json";
import buildingS from "@/data/buildings/polygons/S.json";
import buildingSB from "@/data/buildings/polygons/SB.json";
import buildingSC from "@/data/buildings/polygons/SC.json";
import buildingSH from "@/data/buildings/polygons/SH.json";
import buildingSI from "@/data/buildings/polygons/SI.json";
import buildingSP from "@/data/buildings/polygons/SP.json";
import buildingT from "@/data/buildings/polygons/T.json";
import buildingTA from "@/data/buildings/polygons/TA.json";
import buildingTD from "@/data/buildings/polygons/TD.json";
import buildingV from "@/data/buildings/polygons/V.json";
import buildingVA from "@/data/buildings/polygons/VA.json";
import buildingVE from "@/data/buildings/polygons/VE.json";
import buildingVL from "@/data/buildings/polygons/VL.json";
import buildingX from "@/data/buildings/polygons/X.json";
import buildingZ from "@/data/buildings/polygons/Z.json";

export const CAMPUS_BUILDINGS = [
  buildingAD,
  buildingCC,
  buildingD,
  buildingEV,
  buildingFG,
  buildingGN,
  buildingHC,
  buildingK,
  buildingMB,
  buildingPC,
  buildingPT,
  buildingRF,
  buildingSC,
  buildingSP,
  buildingVA,
  buildingX,
  buildingBB,
  buildingCI,
  buildingDO,
  buildingFA,
  buildingGA,
  buildingGS,
  buildingH,
  buildingLB,
  buildingMI,
  buildingP,
  buildingPY,
  buildingR,
  buildingSH,
  buildingTA,
  buildingVE,
  buildingZ,
  buildingBH,
  buildingCJ,
  buildingEN,
  buildingFB,
  buildingGE,
  buildingHA,
  buildingHU,
  buildingLD,
  buildingM,
  buildingPR,
  buildingQ,
  buildingRR,
  buildingSI,
  buildingTD,
  buildingV,
  buildingB,
  buildingCL,
  buildingER,
  buildingFC,
  buildingGM,
  buildingHB,
  buildingJR,
  buildingLS,
  buildingMU,
  buildingPS,
  buildingRA,
  buildingSB,
  buildingS,
  buildingT,
  buildingVL,
];
